module.exports = __webpack_public_path__ + "static/media/red_x.8ecdfd68.png";